import { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import { Loader } from "@/shared/components";
import { AccessibilitySwitcher, LanguageSwitcher } from "@/features/settings";
import PublicUnitHeaderInfo from "./PublicUnitHeaderInfo";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const isPublicUnit = pathname.startsWith("/warehouse/units/");
  const barcode = isPublicUnit ? pathname.split("/warehouse/units/")[1]?.split("/")[0] || "" : "";

  return (
    <div className="surface-secondary-fill min-h-screen flex flex-col">
      <header className="w-full flex py-4 justify-between items-center px-5">
        <div>{isPublicUnit && barcode ? <PublicUnitHeaderInfo barcode={barcode} /> : null}</div>
        <div className="flex items-center gap-3 xl:mr-0 mr-4">
          <LanguageSwitcher />
          <AccessibilitySwitcher />
        </div>
      </header>
      <main className="grow flex flex-col">
        <Suspense
          fallback={
            <div className="grow flex items-center justify-center">
              <Loader />
            </div>
          }>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
